import { TimeSignature } from "./core";

export const GridResolutionNames = [
    'bar',
    'beat',
    '1/2 beat',
    '1/4 beat',
    '1/8 beat',
    '1/16 beat',
    '1/32 beat',
    '1/64 beat'
]
export type GridResolution = typeof GridResolutionNames[number];

export function gridResolutionToTicks(
    resolution: GridResolution,
    ppq: number,
    timeSignature: TimeSignature
): number {
    switch (resolution) {
        case 'bar':
            return ppq * 4 * timeSignature.numerator/ timeSignature.denominator;
        case 'beat':
            return ppq * 4 / timeSignature.denominator;
        case '1/2 beat':
            return ppq * 2 / timeSignature.denominator;
        case '1/4 beat':
            return ppq * 1 / timeSignature.denominator;
        case '1/8 beat':
            return ppq / 2 / timeSignature.denominator;
        case '1/16 beat':
            return ppq / 4 / timeSignature.denominator;
        case '1/32 beat':
            return ppq / 8 / timeSignature.denominator;
        case '1/64 beat':
            return ppq / 16 / timeSignature.denominator;
        default:
            throw new Error(`Unsupported grid resolution: ${resolution}`);
    }
}